import type {
  MessageTab,
  MessageThreadCounts,
  MessageThreadsResponse,
} from './types'

interface MessageTabMeta {
  id: MessageTab
  label: string
  countKey: keyof MessageThreadCounts | null
}

export const MESSAGE_TAB_META: readonly MessageTabMeta[] = [
  { id: 'all', label: 'All', countKey: null },
  { id: 'awaiting', label: 'Your turn', countKey: 'awaiting' },
  { id: 'with_heard', label: 'With Heard', countKey: null },
  { id: 'resolved', label: 'Resolved', countKey: null },
] as const

export const EMPTY_TAB_TITLE = 'Nothing needs you right now'
export const EMPTY_TAB_ACTION = 'See all messages'
export const NO_RESULTS_TITLE = 'No messages match that search'
export const FIRST_RUN_TITLE = "You haven't messaged us yet"
export const FIRST_RUN_BODY =
  'When you start a conversation with Heard, it will show up here.'

export const postTicketCommentPrompt = (
  ticketId: number,
  body: string
): string => `Post this comment on ticket #${ticketId}: ${body}`

// Zendesk search indexes a write late, so a list fetched right after a reply
// can still show the thread as waiting on the user.
export const isReplyReflected = (
  page: MessageThreadsResponse,
  tab: MessageTab,
  ticketId: number
): boolean => {
  if (page.scope === 'search') return true
  const row = page.threads.find((thread) => thread.ticketId === ticketId)
  if (!row) return tab === 'awaiting' || tab === 'resolved'
  return row.preview?.author === 'you' && row.status !== 'awaiting'
}
